import { Box, Typography, Chip, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, IconButton, Tooltip, TablePagination, TextField, FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import { Edit, Delete, Visibility, CheckCircle } from '@mui/icons-material';
import { ArchiveItem } from '../../types';

interface ArchiveTableProps {
  items: ArchiveItem[];
  loading: boolean;
  total: number;
  page: number;
  limit: number;
  onPageChange: (page: number) => void;
  onEdit: (item: ArchiveItem) => void;
  onDelete: (id: number) => void;
  onTogglePublic: (id: number) => void;
}

const getTypeLabel = (type: string) => {
  const labels: Record<string, string> = { DOCUMENT: 'Документ', PHOTO: 'Фото', VIDEO: 'Видео', AUDIO: 'Аудио', NEWSPAPER: 'Газета', OTHER: 'Другое' };
  return labels[type] || type;
};

export function ArchiveTable({ items, loading, total, page, limit, onPageChange, onEdit, onDelete, onTogglePublic }: ArchiveTableProps) {
  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Название</TableCell>
            <TableCell>Тип</TableCell>
            <TableCell>Категория</TableCell>
            <TableCell>Год</TableCell>
            <TableCell>Статус</TableCell>
            <TableCell>Действия</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {items.map((item) => (
            <TableRow key={item.id} hover>
              <TableCell>{item.title}</TableCell>
              <TableCell>{getTypeLabel(item.type)}</TableCell>
              <TableCell>{item.category}</TableCell>
              <TableCell>{item.year || '-'}</TableCell>
              <TableCell>
                <Chip label={item.isPublic ? 'Публичный' : 'Приватный'} size="small" color={item.isPublic ? 'success' : 'default'} />
              </TableCell>
              <TableCell>
                <Box sx={{ display: 'flex', gap: 0.5 }}>
                  <Tooltip title="Просмотр"><IconButton size="small"><Visibility fontSize="small" /></IconButton></Tooltip>
                  <Tooltip title="Редактировать"><IconButton size="small" onClick={() => onEdit(item)}><Edit fontSize="small" /></IconButton></Tooltip>
                  <Tooltip title={item.isPublic ? 'Скрыть' : 'Опубликовать'}>
                    <IconButton size="small" onClick={() => onTogglePublic(item.id)}><CheckCircle fontSize="small" color={item.isPublic ? 'success' : 'disabled'} /></IconButton>
                  </Tooltip>
                  <Tooltip title="Удалить"><IconButton size="small" onClick={() => onDelete(item.id)} sx={{ color: 'error.main' }}><Delete fontSize="small" /></IconButton></Tooltip>
                </Box>
              </TableCell>
            </TableRow>
          ))}
          {items.length === 0 && !loading && (
            <TableRow><TableCell colSpan={6} align="center"><Typography color="text.secondary">Архив пуст</Typography></TableCell></TableRow>
          )}
        </TableBody>
      </Table>
      <TablePagination component="div" count={total} page={page - 1} onPageChange={(_, newPage) => onPageChange(newPage + 1)} rowsPerPage={limit} rowsPerPageOptions={[]} />
    </TableContainer>
  );
}

interface ArchiveToolbarProps { search: string; onSearchChange: (value: string) => void; typeFilter: string; onTypeFilterChange: (value: string) => void; }
export function ArchiveToolbar({ search, onSearchChange, typeFilter, onTypeFilterChange }: ArchiveToolbarProps) {
  return (
    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, mb: 2 }}>
      <TextField label="Поиск" variant="outlined" size="small" value={search} onChange={(e) => onSearchChange(e.target.value)} sx={{ minWidth: 200 }} />
      <FormControl size="small" sx={{ minWidth: 150 }}>
        <InputLabel>Тип</InputLabel>
        <Select value={typeFilter} label="Тип" onChange={(e) => onTypeFilterChange(e.target.value as string)}>
          <MenuItem value="">Все</MenuItem>
          <MenuItem value="DOCUMENT">Документ</MenuItem>
          <MenuItem value="PHOTO">Фото</MenuItem>
          <MenuItem value="VIDEO">Видео</MenuItem>
          <MenuItem value="AUDIO">Аудио</MenuItem>
          <MenuItem value="NEWSPAPER">Газета</MenuItem>
        </Select>
      </FormControl>
    </Box>
  );
}
